export const API_PARAM = {
  ENTITIES: "file-upload/entities",
  DATASETS: "file-upload/datasets",
  EXPORT_TEMPLATE:"file-upload/entities/export"
};
